import { buildResourcefulRequests, buildSingularResourcefulRequests, executeRequest } from '@utils/requests'

export const unlinkScenarioAsset = (scenarioID, assetID, mode = 'permanent') =>
  executeRequest(`/api/scenarios/${scenarioID}/assets/${assetID}/unlink`, 'PUT', JSON.stringify({ mode }))

export const resourcefulScenarioRequest = (scenarioID, resourceName) => {
  const basePath = `/api/scenarios/${scenarioID}/${resourceName}`

  return buildResourcefulRequests(basePath)
}

export const singularResourcefulScenarioRequest = (scenarioID, resourceName) => {
  const basePath = `/api/scenarios/${scenarioID}/${resourceName}`

  return buildSingularResourcefulRequests(basePath)
}
